<template>
  <v-alert :value="active" :type="type" dense>{{message}}</v-alert>
</template>

<script>
import { mapActions } from "vuex";
import { api as appApi } from "@/store/modules/app";

export default {
  name: "OfflineStatus",
  data: () => ({
    timerId: null,
    online: true
  }),
  mounted() {
    this.offline = !navigator.onLine;
    const onlineHandler = () => {
      const timerId = this.timerId;
      this.timerId = null;

      if (timerId) {
        window.clearTimeout(timerId);
      }
      if (this.online === false) {
        this.timerId = window.setTimeout(() => {
          this.timerId = null;
        }, 5000);
      }
      this.online = true;
      this.setIsOnline(true);
    };

    const offlineHandler = () => {
      this.online = false;
      this.setIsOnline(false);
    };

    const unloadHandler = evt => {
      if (!this.online) {
        const message =
          "Ihre Änderungen werden eventuell nicht gespeichert.\nBitte gehen Sie wieder Online.";
        evt.preventDefault();
        (evt || window.event).returnValue = message;
        return message;
      }
    };

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);
    window.addEventListener("beforeunload", unloadHandler);

    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    });
  },
  computed: {
    active() {
      return this.timerId !== null || !this.online;
    },
    message() {
      if (!this.online) {
        return "Die Anwendung ist offline.";
      } else {
        return "Die Anwendung ist wieder online.";
      }
    },
    type() {
      if (!this.online) {
        return "info";
      } else {
        return "success";
      }
    }
  },
  methods: {
    ...mapActions(appApi.namespace, [appApi.actions.setIsOnline])
  }
};
</script>
